export const DUPLICATE_NAME_ERROR = 'Priority name already exists';

export const getIsDuplicateNameError = (message: string) =>
	message.match(/.*priority.*name.*already exists.*/i);
